export const locale = {
  'DELETECONFIRM' : {
    'TITLE' : 'Delete',
    'MESSAGE' : 'Are you sure you want to delete this orders?',
    'CONFIRM' : 'Yes, delete',
    'DECLINE' : 'Cancel',
    'ORDERNUMBER' : 'Order #',
    'DELETING' : 'Deleting orders',
    'IMAGEDELETE' : 'Are you sure you want to delete this image?',
    'IMAGEDELETE_TITLE' : 'Delete image?',
    'IMAGEDELETE_DELETING' : 'Deleting images',
    'IMAGEDELETE_ERROR' : 'Couldn\'t delete image',
    'IMAGECHANGE_ERROR' : 'Couldn\'t change image',

    'ERROR' : 'Failed to remove orders',
  },
};
